import React from 'react';
import PropTypes from 'prop-types';
import withTimeout from 'react-timeout';
import ReactGA from 'react-ga';

// Redux
import { connect } from 'react-redux';
import * as actions from './actions';
import * as loginActions from 'containers/Login/actions';

// Components
import SplashScreen, { withSplashScreen } from 'components/SplashScreen';
import Layout from 'components/Layout';
import MainHeader from './components/MainHeader';

// Utils
import ChildRoutes from 'utils/ChildRoutes';

export class AppWrapper extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = { isSplashScreenActive: false };
  }

  componentDidMount() {
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
    this.props.getUserPermissions()
    .then(() => {
      this.checkUserPermission();
    });
    const { companyId } = this.props.match.params;
    if (!this.props.checkSession(companyId).then) return;
    this.props.checkSession(companyId)
      .then(() => {
        this.props.fetchSectorList();
        this.props.fetchSitesList();
        this.props.fetchTargets();
        this.props.fetchEnterpriseInfo();
      });
  }

  getSnapshotBeforeUpdate() {
    if (!this.props.isSessionActive) return true;
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      ReactGA.set({ page: window.location.pathname });
      ReactGA.pageview(window.location.pathname);
    }
    if (prevProps.userPermissions !== this.props.userPermissions) {
      const user = this.props.userPermissions.email;
      ReactGA.set({ userId: user });
    }
    if (snapshot) {
      this.sendUserToLogin();
      this.props.fetchTargets();
    }
  }

  render() {

    let currentYear = new Date().getFullYear();

    return (
      <Layout>

        <SplashScreen isVisible={this.state.isSplashScreenActive} />

        <Layout.Header>
          <MainHeader
            {...this.props}
            onSelectSector={this.onSelectSector.bind(this)}
            onClickLogout={this.logoutUser.bind(this)}
            onClickSettings={this.handleClickSettings.bind(this)}
            gotoHome={this.gotoHome.bind(this)}
            canEdit={
              (this.props.userPermissions != null)?
                (this.props.userPermissions.permissions.sites[Object.keys(this.props.userPermissions.permissions.sites)[0]].targets != null) ?
                  this.props.userPermissions.permissions.sites[Object.keys(this.props.userPermissions.permissions.sites)[0]].targets.write:
                  false
              :false}
          />
        </Layout.Header>

        <Layout.Body>
          <Layout.Main>
            <ChildRoutes {...this.props} />
            <div className="app-footer">
              <div className="app-footer-logo">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2605.98 649.79"><title>packiot-dark</title><path d="M2151,444.38c16.47.12,29.66-4.35,40-14,24.06-22.47,27.36-69.41,27.57-107.78.2-49.3-7.79-80.21-25.16-97.29-10.61-10.4-25-15.5-42.86-15h-.08c-17.78-.45-32.26,4.65-42.86,15-17.37,17.08-25.36,48-25.16,97.29.21,38.37,3.51,85.31,27.57,107.78C2120.32,440,2134.19,444.5,2151,444.38Z" fill="none"/><path d="M888,325.65c24-4.24,54.45-25.35,54.28-56.23.17-35-30.26-52-54.28-56.19-2.32-.41-22.34-2.08-27.4-1.51V327.16C865.65,327.69,885.67,326.06,888,325.65Z" fill="none"/><path d="M1139.22,422a20.91,20.91,0,0,0,7.34,16.64c15.33,13.33,49.75,10.6,57.9,9.74V395.57a146.79,146.79,0,0,0-16.1-.86c-13.66,0-31.81,1.87-41.8,10.6C1141.63,409.57,1139.22,415.08,1139.22,422Z" fill="none"/><path d="M2336,136.85h-1.92c-1.91.45-2.9,1.14-.12,78.21l.08,2H2423V512.7h86.33V215h70.1L2606,136.85Z" fill="#CCCCCC"/><path d="M2039.63,474.69c46.36,44.7,110.38,40.78,110.71,40.74.12,0,1.71.08,4.52.08,15.46,0,67.28-3,106.51-40.82,34.22-33,50.4-83.47,48.16-149.85,2.24-66.51-13.94-117-48.16-150-45.3-43.68-107.45-40.94-110.87-40.74-3.43-.16-65.57-3-110.87,40.74-34.22,33-50.41,83.47-48.16,149.85C1989.22,391.22,2005.41,441.7,2039.63,474.69Zm68-249.39c10.6-10.4,25.08-15.5,42.86-15h.08c17.82-.45,32.25,4.65,42.86,15,17.37,17.08,25.36,48,25.16,97.29-.21,38.37-3.51,85.31-27.57,107.78-10.32,9.66-23.51,14.13-40,14-16.82.12-30.69-4.35-41-14C2086,407.9,2082.66,361,2082.45,322.59c-.21-49.3,7.78-80.21,25.15-97.29Z" fill="#CCCCCC"/><rect x="1852.13" y="136.85" width="89.06" height="375.84" fill="#CCCCCC"/><polygon points="1825.05 512.7 1742.32 365.17 1812.05 234.84 1719.03 234.84 1656.4 356.76 1656.4 142.97 1568.89 142.97 1531.34 211.6 1572.81 211.6 1572.81 512.7 1655.05 512.7 1655.05 379.23 1728.62 512.7 1825.05 512.7" fill="#CCCCCC"/><path d="M1545,481.38l-.94-1.63c-3.67-6.48-35-47.51-36.29-49.26l-1.11-1.47-1.59,1c-.53.33-52.68,32.22-86.89,1.88-14.32-12.68-21.49-34.09-22.27-51.91h.25c-.17-1.39-.25-2.86-.29-4.33a46,46,0,0,1,.29-4.93h-.29c.53-17.05,6.4-37.11,18.31-48.69,8.85-8.56,22.18-13.21,37.56-13.17,13.94.08,27.73,3.79,41.06,7.38l1.51.41,32.91-57.9-1.51-1.06a132.18,132.18,0,0,0-183.79,33.11c-16.35,23.52-25.4,53.58-25.52,84.61-.12,30.3,8.28,59.66,23.73,82.74a132.24,132.24,0,0,0,85.47,56,83.39,83.39,0,0,0,15.29,1.31c33.32,0,76.62-15.66,102.51-33Z" fill="#CCCCCC"/><path d="M1061.05,422.25c-.77,33.85,15.09,62.39,43.59,78.26,26.67,14.88,55.25,15.08,80.46,15.29h2.52a306,306,0,0,0,96.32-15.46l1.39-.45V324.67c0-.81-4.41-81-87.43-88.57-3.06-.36-75.28-7.95-119.52,17.91l-1.39.85,20.23,64.27,2.12-1c.33-.17,31.85-15.42,64.27-14.07,18.92.77,29.23,7.95,34.53,13.86,4.73,5.26,6.65,10.81,7,14.68h-45.55C1158.59,332.62,1063.13,335.68,1061.05,422.25Zm143.41-26.68v52.76c-8.15.86-42.57,3.59-57.9-9.74a20.91,20.91,0,0,1-7.34-16.64c0-6.89,2.41-12.36,7.34-16.64,10-8.73,28.14-10.6,41.8-10.6A146.79,146.79,0,0,1,1204.46,395.57Z" fill="#CCCCCC"/><path d="M861.24,402.68c43.71,1.55,82.29-6.61,111.61-23.61,36.74-21.29,58.27-59.66,59-105.29a173.65,173.65,0,0,0-6.44-49.46c-10-35.84-41.88-68-79.31-79.88-26.87-8.57-55.54-8.12-85-6.85l-2.11.08-3.23.1-4.21.12-5,.14-5.67.15-6.18.16-6.52.15-6.7.15-6.74.15-6.6.12-6.31.11c-2,0-3.91.06-5.86.09l-5.27.06h-8.08c-.84,0-1.68,0-2.51-.06-1.29-.05-2.56-.1-3.85-.1V512.7h84.25Zm-.65-191c5.06-.57,25.08,1.1,27.4,1.51,24,4.2,54.45,21.15,54.28,56.19.17,30.88-30.26,52-54.28,56.23-2.32.41-22.34,2-27.4,1.51Z" fill="#CCCCCC"/><circle cx="232.84" cy="234.94" r="45.12" fill="none"/><path d="M586.54,181.17V107.89A53.64,53.64,0,0,1,556.4,95.55L452.49,199.43a53.77,53.77,0,0,1,13.19,31.08h71.53A54,54,0,0,1,586.54,181.17Z" fill="none"/><circle cx="232.84" cy="596.64" r="45.12" fill="none"/><circle cx="411.91" cy="415.79" r="45.12" fill="none"/><circle cx="590.98" cy="54.1" r="45.12" fill="none"/><circle cx="590.98" cy="234.94" r="45.12" fill="none"/><circle cx="411.91" cy="234.94" r="45.12" fill="none"/><circle cx="53.76" cy="54.1" r="45.12" fill="none"/><circle cx="232.84" cy="54.1" r="51.04" fill="#CCCCCC"/><circle cx="411.91" cy="54.1" r="51.04" transform="translate(292.52 452.02) rotate(-80.78)" fill="#CCCCCC"/><path d="M645,54.1A54,54,0,1,0,550.1,89.27l-104,104a53.92,53.92,0,0,0-88,37.28H286.6a53.93,53.93,0,0,0-88-37.28L94.65,89.27a53.79,53.79,0,1,0-6.31,6.25L192.25,199.43a53.76,53.76,0,0,0-.77,70.17L85.38,375.71l.38.38a51,51,0,1,0,.62,78.9l106,106a53.58,53.58,0,1,0,6.37-6.18L92.67,448.73a50.79,50.79,0,0,0-.89-66.87L197.72,275.92a53.88,53.88,0,0,0,88.86-36.52h71.54a54,54,0,0,0,49.34,49.34V362a54,54,0,1,0,8.87,0V288.74a54,54,0,0,0,49.34-49.34h71.54a54,54,0,1,0,58.21-58.2V107.91A54,54,0,0,0,645,54.1ZM537.21,230.51H465.68a53.77,53.77,0,0,0-13.19-31.08L556.4,95.52a53.7,53.7,0,0,0,30.14,12.33v73.29A54,54,0,0,0,537.21,230.51ZM591,9A45.13,45.13,0,1,1,545.86,54.1,45.13,45.13,0,0,1,591,9ZM8.63,54.1A45.13,45.13,0,1,1,53.77,99.22h0A45.19,45.19,0,0,1,8.63,54.1ZM278,596.64a45.13,45.13,0,1,1-45.12-45.13h0A45.17,45.17,0,0,1,278,596.64ZM232.84,280.07A45.13,45.13,0,1,1,278,234.93h0A45.18,45.18,0,0,1,232.84,280.07ZM457,415.8a45.13,45.13,0,1,1-45.12-45.14A45.11,45.11,0,0,1,457,415.8ZM411.9,280.07A45.13,45.13,0,1,1,457,234.94,45.14,45.14,0,0,1,411.9,280.07Zm224.2-45.13A45.13,45.13,0,1,1,591,189.82h0a45.18,45.18,0,0,1,45.13,45.12Z" fill="#CCCCCC"/><circle cx="53.76" cy="234.94" r="51.04" fill="#CCCCCC"/><circle cx="53.76" cy="596.64" r="51.04" fill="#CCCCCC"/><circle cx="411.91" cy="596.64" r="51.04" fill="#CCCCCC"/><circle cx="590.98" cy="596.64" r="51.04" fill="#CCCCCC"/><circle cx="232.84" cy="415.79" r="51.04" fill="#CCCCCC"/><circle cx="590.98" cy="415.79" r="51.04" fill="#CCCCCC"/></svg>
              </div>
              <div className="app-footer-credits">
                &copy; {currentYear} - All rights reserved
              </div>
            </div>
          </Layout.Main>
        </Layout.Body>

      </Layout>
    );
  }

  onSelectSector() {
    this.props.fetchSectorList();
    this.props.fetchSitesList();
  }

  handleClickSettings() {
    this.props.history.push(`/app/${this.props.match.params.companyId}/settings/targets`);
  }

  gotoHome() {
    this.props.history.push(`/app/${this.props.match.params.companyId}/analytics/dashboard/factory/month/lines/ALL/total-production/day`);
  }

  logoutUser() {
    this.props.setTimeout(() => {
      this.setState({ isSplashScreenActive: true });
      this.props.logout();
    }, 130);
  }

  sendUserToLogin() {
    this.props.history.push('/login');
  }

  goto(isBack, path) {
    if (isBack) {
      this.props.history.goBack();
      return;
    }
    this.props.history.push(path);
  }

  checkUserPermission() {
    if(!this.props.userPermissions.permissions.apps.dashboard){
      this.goto(false, '/login/unauthorized');
    }
  }

};

AppWrapper.defaultProps = {
  isSessionActive: null
};

AppWrapper.propTypes = { isSessionActive: PropTypes.bool };

export default connect((store) => ({
  isSessionActive: store.app.isSessionActive,
  sectorList: store.app.sectorList,
  sitesList: store.app.sitesList,
  loggedUser: store.app.loggedUser,
  targets: store.app.targets,
  enterpriseInfo: store.app.enterpriseInfo,
  userPermissions: store.app.userPermissions
}), Object.assign(actions, loginActions))(withSplashScreen(withTimeout(AppWrapper)));
